// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentPatientLookupResultModel } from './extEnrollmentPatientLookupResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CouponEnrollmentPatientMedicalBenefitResponse {
    'data': ExtEnrollmentPatientLookupResultModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CouponEnrollmentPatientMedicalBenefitResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "ExtEnrollmentPatientLookupResultModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return CouponEnrollmentPatientMedicalBenefitResponse.attributeTypeMap;
    }
}
